import {PayloadAction} from "../payload-action.interface";
import {RemarkEntity} from "./remark.entity";
import {RemarkActions} from "./remark.actions";

export function RemarkReducer(state: Array<RemarkEntity> = [], action: PayloadAction) {
  let newState;

  switch (action.type) {
    case RemarkActions.REMOVE:
      return removeRemark(state, action.payload);
    case RemarkActions.ADD:
    case RemarkActions.SET:
      newState = removeRemark(state, action.payload._id);
      return addRemark(newState, action.payload);
    case RemarkActions.ADD_ALL:
      return [...action.payload];
    default:
      return state;
  }
}

function addRemark(state: Array<RemarkEntity>, remark: RemarkEntity): Array<RemarkEntity> {
  return [...state, remark];
}

function removeRemark(state: Array<RemarkEntity>, id: string): Array<RemarkEntity> {
  return state.filter((remark) => remark._id !== id);
}



// WEBPACK FOOTER //
// ./src/store/remark/remark.reducer.ts